module.exports = __webpack_public_path__ + "img/company-config.060d1eca.svg";